<template>
  <div class="topicZero">
    <canvas width="500" height="500" ref="todoChess" style="width:100%;"></canvas>
  </div>
</template>

<script>
import Island from '../lib/island';

export default {
  name: 'topicZero',
  props: {
    question: {
      type: Object,
      default: null,
    },
    reload: {
      type: Number,
    },
  },
  watch: {
    reload() {
      this.initZT();
    },
  },
  data() {
    return {
      selectArr: [], // 选择选项
    };
  },
  created() {
    this.selectArr = this.question.selector.split('||||');
  },
  mounted() {
    this.initZT();
  },
  methods: {
    initZT() {
      const that = this;
      const { Practice } = Island;
      if (this.zp) { this.zp.off(); }
      // eslint-disable-next-line no-new
      this.zp = new Practice({
        $el: this.$refs.todoChess, // canvas对象
        width: 500, // canvas宽度
        type: 0, // 0 执行题，1 判断题, 2 单选题，3 其他类型
        content: this.question.ask_desc, // 内容
        /* 统一正确处理
         * @object code 200 正确
         * @object message 提示信息
         */
        onSuccess(data) {
          console.log(data);
          if (data.code === 200) {
            that.$emit('getResult_chess', '正确');
          }
        },
        /* 统一处理错误
         * @object code 1 落子错误
         * @object message 提示信息
         */
        onError(data) {
          console.log(data);
          if (data.code === 1) {
            that.$emit('getResult_chess', '错误');
          }
        },
      });
    },
    // 获取答案正确与否
    confirmAns(item) {
      if (item === this.answer) {
        this.$emit('getResult_chess', '正确');
      } else {
        this.$emit('getResult_chess', '错误');
      }
    },
    confirm() {
      this.zp.getSelected();
    },
  },
};
</script>
<style scoped lang="scss">
  .topicZero{
    width: 100%;
    height:100%;
    .answers{
      width:halvePx(670);
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto;
      margin-top:halvePx(86);
      img{
        display:inline-block;
        width:halvePx(44);
        height:halvePx(60);
      }
      .answers-choose{
        height:auto;
        .choose-item{
          width:halvePx(540);
          height:halvePx(100);
          background:rgba(250,229,179,1);
          border:halvePx(2) solid rgba(196, 178, 135, 1);
          border-radius:halvePx(50);
          margin:auto;
          font-size:halvePx(30);
          font-family:PingFang-SC-Regular;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:halvePx(100);
          text-align: center;
          margin:halvePx(20);
        }
      }
    }
    .button{
      width:halvePx(200);
      height:halvePx(100);
      line-height: halvePx(100);
      text-align: center;
      background:rgba(250,229,179,1);
      border:halvePx(2) solid rgba(196, 178, 135, 1);
      border-radius:halvePx(50);
      margin:halvePx(20) auto;
      font-size:halvePx(30);
      font-family:PingFang-SC-Regular;
      font-weight:400;
      color:rgba(51,51,51,1);
    }
  }
</style>
